module.exports = __webpack_public_path__ + "img/bitfluentSquareLogo.f911cf88.png";